// ========= START: src/components/Background.js =========

import React from 'react';

const backgroundVideoStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -1,
};

const backgroundImageStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  zIndex: -1,
};

function Background({ background }) {
  if (!background || !background.src) {
    return null; // Don't render anything if no source is provided
  }

  if (background.type === 'video') {
    return (
      <video
        style={backgroundVideoStyle}
        src={background.src}
        autoPlay
        loop
        muted
        playsInline
      />
    );
  }

  // Default to image
  return (
    <div style={{ ...backgroundImageStyle, backgroundImage: `url(${background.src})` }} />
  );
}

export default Background;
// ========= END: src/components/Background.js =========